var map = {
	"./PM_2.2.2.png": 97662,
	"./PM_2.3.2.png": 89803,
	"./PM_3.2.2.png": 68117,
	"components/Catalog/PM/img/glass/pr/prPlusPerGold/PM_2.2.2.png": 97662,
	"components/Catalog/PM/img/glass/pr/prPlusPerGold/PM_2.3.2.png": 89803,
	"components/Catalog/PM/img/glass/pr/prPlusPerGold/PM_3.2.2.png": 68117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42604;